import * as icons from '@insify/design-system/line-icons';
import { textSm, textSmSemibold } from '@insify/design-system/typography';
import clsx from 'clsx';

import { Slider } from '../../Slider';

import * as styles from './ClaimExamplesSlider.module.css';

import type React from 'react';

type ClaimType = {
  Icon: string;
  situation: string;
  outcome: string;
};

const Claim: React.FC<ClaimType> = ({ Icon, situation, outcome }) => {
  if (Icon in icons === false) {
    // TODO Sentry
  }
  const IconComponent = icons[Icon as keyof typeof icons];
  return (
    <div className={styles.claim}>
      <IconComponent className={styles.claimIcon} />
      <p className={textSmSemibold}>{situation}</p>
      <p className={clsx(textSm, styles.localizedLikelyOutcome)}>{outcome}</p>
    </div>
  );
};

type Props = Omit<React.ComponentProps<typeof Slider>, 'slides'> & {
  claims: ClaimType[];
};

export const ClaimExamplesSlider = ({ claims, ...props }: Props) => {
  return (
    <Slider
      {...props}
      alignStepper='left'
      slides={claims.map((claim) => (
        <Claim key={claim.situation} {...claim} />
      ))}
    />
  );
};
